module.exports = __webpack_public_path__ + "static/media/upload.3726c5fb.svg";